export const VendaStatus = {
    ATIVA: 'ATIVA',
    CADASTRO_PARCIAL: 'CADASTRO_PARCIAL',
    CANCELADA: 'CANCELADA',
    FINALIZADA: 'FINALIZADA',
    PAGAMENTO_RECUSADO: 'PAGAMENTO_RECUSADO',
    PERIODO_GRATIS: 'PERIODO_GRATIS'
};

const VendaStatusLabel = {
    ATIVA: 'Ativa',
    CADASTRO_PARCIAL: 'Cadastro parcial',
    CANCELADA: 'Cancelada',
    FINALIZADA: 'Finalizada',
    PAGAMENTO_RECUSADO: 'Pagamento recusado',
    PERIODO_GRATIS: 'Período grátis'
};

export const getVendaStatusList = () => {
    return Object.keys(VendaStatus).map(value => ({
        value,
        name: VendaStatusLabel[value]
    }));
};
